export { default as jsonRequire } from './jsonRequire';